import Api from '@/api'

const state = {
    items: [],
}

const getters = {
    items: state => state.items,
}

const mutations = {
    setItems(state, items) {
        state.items = items
    },
}

const actions = {
    updateClients: ({ commit }, items) => commit('setItems', items),

    fetch ({commit}) {
        // axios request
        return Api.request('get', 'api/clients').then(({data}) => {
            commit('setItems', data.clients)
        })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
